import { WriteBatchPreconditionFailedError, } from '@rammetec/data-access';
import { ConcurrentModificationException } from './concurrentModificationException.js';
/**
 * Commits the batch, translating a server precondition refusal into
 * ConcurrentModificationException — the same error as the early check, so the
 * console does not need to know compare-and-set exists.
 */
export async function commitWriteBatch(batch) {
    try {
        await batch.commit();
    }
    catch (error) {
        if (error instanceof WriteBatchPreconditionFailedError) {
            throw new ConcurrentModificationException();
        }
        throw error;
    }
}
//# sourceMappingURL=commitWriteBatch.js.map